import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import FontHeading4 from '../../../../../../components/fonts/font-heading4/font-heading4';
import FontHeading5 from '../../../../../../components/fonts/font-heading5/font-heading5';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../components/fonts/font-props';

import { OrderEligibilityDisplayService, ItemEligibilityDto } from '../order-eligibility-display.service';

interface EligibilitySummaryProps {
    filteredItems: ItemEligibilityDto[];
    items: ItemEligibilityDto[];
}

const EligibilitySummary: React.FC<EligibilitySummaryProps> = ({ 
    filteredItems, 
    items 
}) => {
    return (
        <div className="eligibility-summary-section">
            <FontHeading4 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                Eligibility Summary
            </FontHeading4>
            <div className="summary-stats">
                <div className="stat-card">
                    <FontHeading5 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                        Total Items
                    </FontHeading5>
                    <FontBody2 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                        {filteredItems.length} {filteredItems.length !== items.length ? `of ${items.length}` : ''}
                    </FontBody2>
                </div>
                <div className="stat-card">
                    <FontHeading5 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                        Eligible Items
                    </FontHeading5>
                    <FontBody2 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                        {filteredItems.filter(item => OrderEligibilityDisplayService.isItemEligible(item)).length}
                    </FontBody2>
                </div>
                <div className="stat-card">
                    <FontHeading5 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                        Ineligible Items
                    </FontHeading5>
                    <FontBody2 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                        {filteredItems.filter(item => !OrderEligibilityDisplayService.isItemEligible(item)).length}
                    </FontBody2>
                </div>
            </div>
        </div>
    );
};

export default EligibilitySummary;
